import configSelectors from 'selectors/configuration';
import configEnums from 'enums/configuration';
import configEvents from 'events/configuration';
import uiEnums from 'enums/ui';
import showOnboarding from 'actions/ui/showOnboarding';
import beginChat from 'actions/ui/beginChat';
import showSelfService from 'actions/ui/showSelfService';
import { isClientReady, hasActiveSession } from 'app/modules';
import selfServiceEvents from 'events/selfService';
import { isAlternateBucket } from 'lib/handleBucketLogic';

export default function evaluateStageChange(dispatch, getState) {
  const state = getState();
  const widgetType = configSelectors.getWidgetType(state.configuration);

  // do not use STAGES with self service
  if (
    widgetType === configEnums.WIDGET_TYPES.SELF_SERVICE ||
    widgetType === configEnums.WIDGET_TYPES.DEMO_SELF_SERVICE ||
    // AB Testing, remove when experiment is over
    isAlternateBucket(state.configuration.abTestingBucket)
  ) {
    dispatch(showSelfService());
    let isThrottled = !configSelectors.getInPercentageRollout(state.configuration);
    if (isThrottled) {
      dispatch(selfServiceEvents.throttleSelfServiceChat());
    } else {
      dispatch(selfServiceEvents.unthrottleSelfServiceChat());
    }

    return uiEnums.STAGES.SELF_SERVICE;
  }

  if (hasActiveSession(state)) {
    dispatch(beginChat());
    return uiEnums.STAGES.CHAT;
  }

  if (!configSelectors.getWithinOfficeHours(state.configuration)) {
    dispatch(configEvents.closeOffice());
    return uiEnums.STAGES.CHAT_CLOSED;
  }

  if (!configSelectors.getInPercentageRollout(state.configuration)) {
    dispatch(configEvents.throttleChat());
    return uiEnums.STAGES.CHAT_THROTTLED;
  }

  if (isClientReady(state)) {
    dispatch(beginChat());
    return uiEnums.STAGES.CHAT;
  }

  if (configSelectors.getOnboardingEnabled(state.configuration)) {
    dispatch(showOnboarding());
    return uiEnums.STAGES.ONBOARDING;
  }

  dispatch(beginChat());
  return uiEnums.STAGES.CHAT;
}
